<template>
    <div>
        <MobileUnauthenticatedMenu v-if="menu === 'unauthenticated'" @loginClick="menu = 'login'" />
        <Login v-if="menu === 'login'" @backClick="menu = 'unauthenticated'" @signUpClick="menu = 'signUp'" @forgotClick="menu = 'reset'" />
        <SignUp v-if="menu === 'signUp'" @backClick="menu = 'unauthenticated'" @loginClick="menu = 'login'" />
        <ResetPassword v-if="menu === 'reset'" @backClick="menu = 'login'" @sendClick="menu = 'resetMessage'" />
        <ResetMessage v-if="menu === 'resetMessage'" @backClick="menu = 'login'" />
    </div>
</template>

<script>
import MobileUnauthenticatedMenu from '@/components/header/nav-items/MobileUnauthenticatedMenu.vue';
import MobileAuthenticatedMenu from '@/components/header/nav-items/MobileAuthenticatedMenu.vue';
import Login from '@/components/header/nav-items/Login.vue';
import SignUp from '@/components/header/nav-items/SignUp.vue';
import ResetPassword from '@/components/header/nav-items/ResetPassword.vue';
import ResetMessage from '@/components/header/nav-items/ResetMessage.vue';

export default {
    components: {
        MobileUnauthenticatedMenu,
        MobileAuthenticatedMenu,
        Login,
        SignUp,
        ResetPassword,
        ResetMessage
    },
    data() {
        return {
            menu: 'unauthenticated'
        };
    }
};
</script>
